
<template>
  <!--会员详情-->
  <div class="advanced-form">
    <a-form layout="vertical">
      <div class="card">
        <div class="card-head">
          <h3>基本信息</h3>
        </div>
        <div class="card-body">
          <a-row type="flex">
            <a-col v-for="(item, index) of baseInfo" :key="index" :span="8">
                <a-form-item class="value-indent" :label="item.key == 'img'? '':item.label">
                  <div class="pic-box" v-if="item.key=='img'">
                    <img :src="item.value" alt="">
                  </div>
                  <span v-if="item.key!='img'" class="ant-form-text">{{item.value}}</span>
                </a-form-item>
              </a-col>
          </a-row>
        </div>
      </div>
    </a-form>
    <div class="card">
      <div class="card-head">
        <h3>项目信息</h3>
      </div>
      <div class="card-body">
        <x-tabula
          ref="table"
          rowKey="id"
          :columns="loginColumns"
          :listApi="loginListApi"
          :rowSelection="false"
        >
          <!-- :dataSource="detailData.goods" -->
         <template slot="opt_img" slot-scope="{row}">
            <img style="height: 44px;width:auto" :src="row.img" alt="">
          </template>
          <template slot="opt_kc" slot-scope="{row}">
            {{row.stock == -1? '不限':`${row.stock}`}}
          </template>
          <template slot="opt_xg" slot-scope="{row}">
            {{row.limitNumber == -1? '不限':`${row.limitNumber}`}}
          </template>
          <template slot="opt_h" slot-scope="{row}">
            <a-tooltip :title="row.introduce">
              <div class="feed-over-text" @click="showDetail(row.introduce)">{{row.introduce}}</div>
            </a-tooltip>
          </template>
          <template slot="opt_money" slot-scope="{row}">
            <span>{{row.price | toMoney}}</span>
          </template>

        </x-tabula>
      </div>
    </div>
    <div class="card">
      <div class="card-head">
        <h3>活动设置</h3>
      </div>
      <div class="card-body">
        <a-row type="flex">
          <a-col v-for="(item, index) of actionsetInfo" :key="index" :span="8">
            <a-form-item class="value-indent" :label="item.key == 'img'? '':item.label">
              <div v-if="item.model=='yesorno'">
                <span>{{item.value == 1? '是':'否'}}</span>
              </div>
              <div v-else-if="item.key=='applyMax'">
                <span>{{item.value == -1? '不设上限':`${item.value}`}} </span>
              </div>
              <span v-else class="ant-form-text">{{item.value}}</span>
            </a-form-item>
          </a-col>

        </a-row>
      </div>
    </div>

    <!--商品简介的弹窗-->
    <a-modal
      title="商品简介"
      :visible="introduceVisible"
      @cancel="introduceVisible=false"
      :footer="null"
      :maskClosable="true"
      :keyboard="true"
      destroyOnClose
      centered
      :width="900"
    >
      <div>{{introduceContent}}</div>
    </a-modal>

  </div>
</template>

<script>
export default {
  name: 'memberDetail',
  data () {
    return {
      introduceContent: '',
      introduceVisible: false,
      detailData: {

      },
      listApi: {
        url: '',
        resHandle: '',
        searchHandle: ''
      },
      loginListApi: {
        url: '',
        resHandle: '',
        searchHandle: ''
      },
      baseInfo: [
        {key: 'nickName', label: '昵称', value: ''},
        {key: 'mobile', label: '手机号', value: ''},
        {key: 'img', label: '活动封面', value: ''},
        {key: 'createTime', label: '发起时间', value: ''},
        {key: 'title', label: '活动标题', value: ''},
        {key: 'typeDesc', label: '活动类型', value: ''},
        {key: 'startTime', label: '活动开始时间', value: ''},
        {key: 'endTime', label: '活动结束时间', value: ''},
        {key: 'closeTime', label: '活动截止时间', value: ''}
      ],
      actionsetInfo: [
        {key: 'applyMax', label: '人数上限', value: ''},
        {key: 'model', label: '拼团模式', value: ''},
        {key: 'isApplyTimes', label: '允许多次报名', value: '', model: 'yesorno'},
        {key: 'isAllowCancel', label: '允许取消', value: '', model: 'yesorno'},
        {key: 'applyInfo', label: '报名需填写信息', value: ''}
      ],
      columns: [
        { title: '商品名称', dataIndex: '', align: 'left', width: '' },
        { title: '单价', dataIndex: '', align: 'left', width: '' },
        { title: '数量(件)', dataIndex: '', align: 'left', width: '' },
        { title: '金额', dataIndex: '', align: 'left', width: '' },
        { title: '到期时间', dataIndex: '', align: 'left', width: '', scopedSlots: {customRender: 'expireTime'} }
      ],
      loginColumns: [
        { title: '商品图', dataIndex: 'img', align: 'left', width: '', scopedSlots: {customRender: 'img'} },
        { title: '标题', dataIndex: 'title', align: 'left', width: '' },
        { title: '商品简介', dataIndex: 'introduce', align: 'left', width: '', scopedSlots: {customRender: 'h'}},
        { title: '单价', dataIndex: 'price', align: 'left', width: '', scopedSlots: {customRender: 'money'}},
        { title: '库存', dataIndex: 'stock', align: 'left', width: '', scopedSlots: {customRender: 'kc'}},
        { title: '限购数量', dataIndex: 'limitNumber', align: 'left', width: '', scopedSlots: {customRender: 'xg'}}
      ],
      tableData: []
    };
  },
  filters: {
    toMoney (val) {
      if (val != null) {
        return '￥' + Number(val).toFixed(2);
      } else {
        return '';
      }
    }
  },
  created () {
    this.loginListApi.url = `/activity/goodsInfo/${this.$route.query.id}`;
    this.getDetail();
  },
  beforeRouteEnter (to, from, next) {
    next();
    setTimeout(() => {
      document.getElementsByClassName('layout-content')[0].style.padding = '0px';
      document.getElementsByClassName('layout-content')[0].style.backgroundColor = 'transparent';
    }, 0);
  },
  beforeRouteLeave (to, from, next) {
    document.getElementsByClassName('layout-content')[0].style.padding = '16px';
    document.getElementsByClassName('layout-content')[0].style.backgroundColor = '#fff';
    next();
  },
  methods: {
    /* 查看项目内容 */
    showDetail (content) {
      this.introduceContent = content;
      this.introduceVisible = true;
    },
    getDetail () {
      this.$get({
        url: `/activity/${this.$route.query.id}`, //
        params: {}
      }).then(({data}) => {
        this.detailData = data;
        for (let item in data) {
          this.baseInfo.forEach((el) => {
            if (el.key === item) {
              el.value = data[item];
            }
          });
          let str = '';
          if (data.isApply == 1) {
            str += '是，';
            if (data.applyMin == -1) {
              str += '人数不限';
            } else {
              str += `${data.applyMin}人成团`;
            }
          } else {
            str = '否';
          }

          this.actionsetInfo.forEach((el) => {
            if (el.key == 'model') {
              el.value = str;
            } else if (el.key === item) {
              el.value = data[item];
            }
          });
        }
      });
    }
  }
};
</script>
<style scoped >
.pic-box{
  width:200px;
  height: 70px;
  max-height: 70px;
  overflow: hidden;
}
.pic-box img{
  height: 70px;
  width: auto !important;
  max-height: 70px;
}
  .card{
    margin-bottom:24px;
  }
</style>
